<template>
    <v-dialog v-model="dialog" lazy absolute>
      <v-btn icon slot="activator">
        <v-icon>help</v-icon>
      </v-btn>
      <v-card>
        <v-card-title>
          <div class="headline" v-text='title' ></div>
        </v-card-title>
        <v-card-text v-text='text' ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialog = false">Got it</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'HelpDialog',
  props: {
    title: { type: String, default: '' },
    text: { type: String, default: '' }
  },
  data () {
    return {
      dialog: false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// HelpDialog.vue?6097d2be